/**
 * Calculates the percentage of a value in relation to a total.
 * @example
 * getPercentage(100, 25) // 25
 * @returns A number representing the percentage of the value in relation to the total.
 * @category Utils
 */
export const getPercentage = (total: number, value: number, fixed = 1): number =>
  Number.parseFloat(Math.abs((value * 100) / total).toFixed(fixed))
